import * as React from "react"
import "@fontsource-variable/dm-sans"
import TemplateV3 from "../../../components/builder/templates/TemplateV3"
import { TEMPLATE_ID } from "./config/template-id"
import "./overrides.css"

/**
 * Pillframe: Free Template 2 in DM Sans, with softer corners.
 *
 * It draws inside its own wrapper (`lib-pillframe`) and overrides.css only styles inside that wrapper. Written against the bare
 * `.mk-v3`, the overrides also changed Free Template 2, whose root is the same class, and the two looked identical.
 */
const entry = {
  id: TEMPLATE_ID,
  worth: 95000,
  label: "Library Template 2",
  blurb: "Compact DM Sans variation of Free Template 2.",
  premium: true,
  from: "library/template-2",
  ported: true,
  Component: props => (
    <div className="lib-pillframe">
      <TemplateV3 {...props} />
    </div>
  ),
}

export default entry
